export interface ContractorTypeOption {
  /** Stored on the contact's contractor profile as `contractor_type`. */
  value: string;
  label: string;
}

/**
 * The trades or specialties a business's own contractors are picked from, coded up
 * per business rather than left to a free-text field: one cleaning company might
 * distinguish domestic from carpet and window cleans, another trade entirely might
 * offer something else again. A slug with no entry here just gets the single
 * default option below.
 */
const CONTRACTOR_TYPES: Record<string, ContractorTypeOption[]> = {
  maid2clean: [
    // Stored as 'cleaner' from before it was called General Cleaning.
    { value: 'cleaner', label: 'General Cleaning' },
    { value: 'deep_cleaning', label: 'Deep Cleaning' },
    { value: 'gutter_cleaning', label: 'Gutter Cleaning' },
    { value: 'garden_maintenance', label: 'Garden Maintenance' },
    { value: 'window_cleaning', label: 'Window Cleaning' },
    { value: 'oven_cleaning', label: 'Oven Cleaning' },
    { value: 'carpet_cleaning', label: 'Carpet Cleaning' },
    { value: 'pressure_cleaning', label: 'Pressure Cleaning' },
    { value: 'lawn_mowing', label: 'Lawn Mowing' },
  ],
};

const DEFAULT_TYPES: ContractorTypeOption[] = [{ value: 'general', label: 'General' }];

/** The type-of-work options this business's contractors choose from. */
export const contractorTypeOptions = (slug: string): ContractorTypeOption[] =>
  CONTRACTOR_TYPES[slug] ?? DEFAULT_TYPES;
